
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-emerald-50">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative bg-slate-900 text-white py-20 bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(15, 23, 42, 0.8), rgba(15, 23, 42, 0.8)), url('https://public.readdy.ai/ai/img_res/6aae624a865faedd9cc88a63fae2a079.jpg')`
        }}
      >
        <div className="container mx-auto px-6">
          <div className="max-width-4xl">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">Yazan Al Homsi</h1>
            <p className="text-2xl md:text-3xl text-emerald-400 mb-8">
              Venture Capitalist Bridging Middle East &amp; North America
            </p>
            <p className="text-xl text-gray-300 mb-8 max-w-3xl leading-relaxed">
              Yazan Al Homsi specializes in small-cap sustainability, clean tech, healthcare. 
              Founders Round Capital (Vancouver), Catalyst Communications DMCC (Dubai). 12+ years PwC, CFA.
            </p>
            <p className="text-lg text-gray-300 mb-12 max-w-4xl leading-relaxed">
              Yazan Al Homsi's approach combines deep financial analysis with cross-continental market insights, 
              identifying breakthrough technologies before they gain mainstream attention.
            </p>
            
            {/* Stats */}
            <div className="grid md:grid-cols-4 gap-6 mb-12">
              <div className="text-center">
                <div className="text-3xl font-bold text-emerald-400">$357M</div>
                <div className="text-sm text-gray-300">Exit (Medicago 2013)</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-emerald-400">12+</div>
                <div className="text-sm text-gray-300">Years PwC Director</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-emerald-400">$300B+</div>
                <div className="text-sm text-gray-300">Total Addressable Market</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-emerald-400">ESG</div>
                <div className="text-sm text-gray-300">First Approach</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Portfolio Section */}
      <section className="py-20 bg-gradient-to-r from-white via-blue-50 to-emerald-50">
        <div className="container mx-auto px-6">
          <h2 className="text-4xl font-bold text-slate-900 text-center mb-16">Investment Portfolio</h2>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-gray-50 rounded-lg p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-emerald-500 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-recycle-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">Aduro</h3>
              <p className="text-lg font-bold text-emerald-600 mb-4">NASDAQ: ADUR | CSE: ACT | FSE: 9D5</p>
              <p className="text-gray-700 mb-6">AI recycling technology achieving 95% efficiency, backed by TotalEnergies (EPA: TTE) partnership and Fortune 500 partnerships.</p>
              <button className="bg-emerald-500 hover:bg-emerald-600 text-white font-bold py-2 px-4 rounded-lg transition-colors cursor-pointer whitespace-nowrap">
                Learn More
              </button>
            </div>
            
            <div className="bg-gray-50 rounded-lg p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-blue-500 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-leaf-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">Charbone Hydrogen</h3>
              <p className="text-gray-600 mb-4">Green Energy</p>
              <p className="text-gray-700 mb-6">Leading green hydrogen production technology with Quebec and Michigan facilities for sustainable energy solutions.</p>
              <button className="bg-emerald-500 hover:bg-emerald-6   text-white font-bold py-2 px-4 rounded-lg transition-colors cursor-pointer whitespace-nowrap">
                View Details
              </button>
            </div>
            
            <div className="bg-gray-50 rounded-lg p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-green-500 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-hospital-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">Medicago</h3>
              <p className="text-gray-600 mb-4">$357M Exit</p>
              <p className="text-gray-700 mb-6">Pharmaceutical company successfully exited for $357M, demonstrating proven track record.</p>
              <button className="bg-emerald-500 hover:bg-emerald-600 text-white font-bold py-2 px-4 rounded-lg transition-colors cursor-pointer whitespace-nowrap">
                Learn More
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Media Coverage */}
      <section className="py-20 bg-gradient-to-l from-slate-100 via-blue-100 to-emerald-100">
        <div className="container mx-auto px-6">
          <h2 className="text-4xl font-bold text-slate-900 text-center mb-16">Featured In</h2>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-lg p-6 shadow-lg text-center">
              <img 
                src="https://readdy.ai/api/search-image?query=Global%20Banking%20and%20Finance%20magazine%20logo%20style%20publication%20cover%2C%20professional%20financial%20media%20branding%2C%20navy%20blue%20and%20gold%20color%20scheme%2C%20sophisticated%20business%20publication%20design&width=300&height=200&seq=gbf-logo&orientation=landscape"
                alt="Global Banking & Finance"
                className="w-full h-32 object-cover rounded-lg mb-4"
              />
              <h3 className="text-xl font-bold text-slate-900">Global Banking &amp; Finance</h3>
            </div>
            
            <div className="bg-white rounded-lg p-6 shadow-lg text-center">
              <img 
                src="https://readdy.ai/api/search-image?query=Boss%20Magazine%20publication%20cover%20design%2C%20executive%20business%20magazine%20branding%2C%20professional%20corporate%20media%20styling%2C%20modern%20business%20publication%20layout&width=300&height=200&seq=boss-mag&orientation=landscape"
                alt="Boss Magazine"
                className="w-full h-32 object-cover rounded-lg mb-4"
              />
              <h3 className="text-xl font-bold text-slate-900">Boss Magazine</h3>
            </div>
            
            <div className="bg-white rounded-lg p-6 shadow-lg text-center">
              <img 
                src="https://readdy.ai/api/search-image?query=Digital%20Journal%20online%20publication%20branding%2C%20modern%20digital%20media%20logo%20design%2C%20technology%20news%20publication%20styling%2C%20clean%20professional%20web%20media%20design&width=300&height=200&seq=digital-journal&orientation=landscape"
                alt="Digital Journal"
                className="w-full h-32 object-cover rounded-lg mb-4"
              />
              <h3 className="text-xl font-bold text-slate-900">Digital Journal</h3>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-slate-900 via-slate-800 to-emerald-900 text-white">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold mb-8">Ready to Discuss Investment Opportunities?</h2>
          <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto">
            Connect with Yazan Al Homsi to explore ESG-focused investment strategies and sustainable technology partnerships.
          </p>
          <a 
            href="/contact" 
            className="inline-block bg-emerald-500 hover:bg-emerald-600 text-white font-bold py-4 px-8 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
          >
            Get In Touch
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
